var map = {
	"./apple.jpg": 490,
	"./aws.jpg": 491,
	"./cruise.jpg": 492,
	"./facebook.png": 493,
	"./google.jpg": 494,
	"./linkedin.jpg": 495,
	"./microsoft.jpg": 496,
	"./salesforce.jpg": 497,
	"./twitter.jpg": 498,
	"./uber.jpg": 405,
	"./waymo.jpg": 499,
	"./workday.jpg": 500
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 824;